document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('quantity-breaks').forEach(quantityBreaks => {
    const variantsScript = quantityBreaks.querySelector(
      'script[type="application/json"]'
    );

    if (!variantsScript) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      console.error('[Quantity Break Variant Images]', error);
      return;
    }

    quantityBreaks
      .querySelectorAll('.quantity-break__selector-item')
      .forEach(selectorItem => {
        const selects = selectorItem.querySelectorAll(
          '.quantity-break__variant-select'
        );

        const image = selectorItem.querySelector(
          '.quantity-break__variant-image img'
        );

        if (!selects.length || !image) return;

        const updateImage = () => {
          const selectedOptions = Array.from(selects).map(
            select => select.value
          );

          const variant = variants.find(v => {
            return v.options.every(
              (option, index) => option === selectedOptions[index]
            );
          });

          if (!variant) return;

          const imageSrc =
            variant.featured_image?.src ||
            variant.featured_image ||
            variant.image;

          if (!imageSrc) return;

          image.src = imageSrc;
          image.alt = variant.name || variant.title || '';

          selectorItem.dataset.selectedId = variant.id;
        };

        selects.forEach(select => {
          select.addEventListener('change', updateImage);
        });

        updateImage();
      });
  });
});